import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import AdminReviewModeration from './AdminReviewModeration';

// Import the existing ReportsManager component
const ReportsManager = () => {
  // This will be imported from the main file
  return null;
};

export const AdminReportsTab = ({ ReportsManagerComponent }) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Reported Posts</CardTitle>
        </CardHeader>
        <CardContent>
          {ReportsManagerComponent ? <ReportsManagerComponent /> : <ReportsManager />}
        </CardContent>
      </Card>

      <Card data-testid="admin-marketplace-reviews-card">
        <CardHeader>
          <CardTitle>Marketplace Reviews</CardTitle>
        </CardHeader>
        <CardContent>
          <AdminReviewModeration />
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminReportsTab;
